import { Controller } from "@hotwired/stimulus"

// Chips that show only the targets of one category. A target carries
// data-category-id ("none" when it has no category); an empty selection is
// "Todos". Hiding never removes elements, so form inputs inside a hidden target
// (the POS quantity fields) keep their value and still submit.
export default class extends Controller {
  static targets = ["chip", "item"]
  static values = { selected: { type: String, default: "" } }

  select({ params: { id } }) {
    this.selectedValue = id
  }

  selectedValueChanged() {
    this.chipTargets.forEach((chip) => {
      chip.classList.toggle("btn-primary", chip.dataset.categoryFilterIdParam === this.selectedValue)
    })
    this.itemTargets.forEach((item) => this.#apply(item))
  }

  // An element added after load (a turbo_stream) obeys the current filter too.
  itemTargetConnected(item) {
    this.#apply(item)
  }

  #apply(item) {
    item.hidden = this.selectedValue !== "" && item.dataset.categoryId !== this.selectedValue
  }
}
